import React, {useContext, useEffect, useState} from 'react';
import {DataContext} from '../../../../../utils/DataProvider';
import {DeathServices} from '../services/DeathServices';
import {createOrUpdateDataFull, maskInput} from '../../../../../utils/utils';
import {DatePickerHelper} from '../../../utils/datePickerHelper';
import {MASKS} from '../../../../../utils/constants';
import {DatagridActionsHelper} from '../../../utils/datagridActionsHelper';
import DataGrid from '../../../../../components/DataGrid';

const Death = () => {
  const {state, stateFetchParams, stateMessage, filterParams} = useContext(DataContext);
  const [data, setData] = useState(null);
  const [total, setTotal] = useState(0);
  const [reset, setReset] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const response = await DeathServices.list({
          ...stateFetchParams,
          ...filterParams,
        });
        const {data: currentData} = response;

        setData(currentData.resultList);
        setTotal(currentData.size);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [reset, JSON.stringify(stateFetchParams).toLowerCase(), JSON.stringify(filterParams).toLowerCase()]);// eslint-disable-line

  const validationFindData = (temp) => {
    const validates = temp.map((item) => item.validated);
    return validates.length && validates.includes(true);
  };

  const handleValidateCallback = async (rows, field, checked) => {
    const promises = [];
    rows.forEach((row) => {
      if (row.notCreated) return;

      promises.push(createOrUpdateDataFull({id: row.id, validated: checked}, state, DeathServices.post, DeathServices.put));
    });

    const response = await Promise.all(promises);
    setReset(!reset);
    return response;
  };

  const handleChange = async (inputs) => {
    if (!inputs.date) {
      const date = DatePickerHelper.newDate();
      Object.assign(inputs, {date});
    }

    if (inputs?.validated == null) {
      Object.assign(inputs, {validated: false});
    }

    Object.assign(inputs, {status: false});

    try {
      return await createOrUpdateDataFull(inputs, state, DeathServices.post, DeathServices.put);
    } catch (error) {
      return error;
    } finally {
      setReset(!reset);
    }
  };

  const columns = [
    {
      key: 'date',
      field: 'date',
      name: 'Data',
      required: true,
      textAlign: 'Center',
      width: '20%',
      ...DatePickerHelper.dailyAndMonth(state),
    },
    {
      key: 'category_livestock',
      valueKey: 'category_livestock.title',
      field: 'category_livestock',
      name: 'Categoria',
      textAlign: 'Center',
      width: '30%',
      required: true,
      editType: 'dropdownedit',
      groupBy: (option) => option.category_livestock,
      optionsFetch: async () => DeathServices.categoryAnimal(),
    },
    {
      key: 'amount',
      field: 'amount',
      name: 'Quantidade',
      width: '15%',
      textAlign: 'Center',
      required: true,
      editType: 'numericedit',
      extraParams: {
        minValue: 1,
      },
    },
    {
      key: 'category_death_reason',
      valueKey: 'category_death_reason.title',
      field: 'category_death_reason',
      name: 'Motivo',
      textAlign: 'Center',
      width: state?.user?.user_type === 'CUSTOMER' ? '35%' : '25%',
      required: true,
      editType: 'dropdownedit',
      groupBy: (option) => option.category_death_reason,
      optionsFetch: async () => DeathServices.categoryDeathsReason(),
    },
    {
      key: 'validated',
      field: 'validated',
      name: 'Validar',
      width: '10%',
      textAlign: 'Center',
      editType: 'booleanedit',
      validationHeader: {showLabel: false, validationFindData},
    },
  ];

  const actions = DatagridActionsHelper.actions({
    handleDelete: async (value) => {
      try {
        const response = await DeathServices.delete(value.id);
        setReset(!reset);
        return response;
      } catch (error) {
        return error;
      }
    },
  });

  return (
    <>
      {stateMessage}
      {data && (
        <DataGrid
          onChange={handleChange}
          validateCallback={handleValidateCallback}
          header={columns}
          data={data}
          width="inherit"
          keyProp="key"
          keyValueProp="valueKey"
          titleProp="name"
          editable=""
          actions={actions}
          totalItems={total}
          accumulators={{
            'Total geral': {
              columns: ['amount'],
              itemOperation: (acc, line, key) => (acc += line[key]),
              resultOperation: (acc) => {
                return maskInput({value: acc, type: MASKS.DOUBLE});
              },
            },
          }}
        />
      )}
    </>
  );
};

export default Death;
